import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { renderSlot as _renderSlot, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = n => (_pushScopeId("data-v-cbbb06d6"), n = n(), _popScopeId(), n);
var _hoisted_1 = ["id", "data-cy", "name", "autocomplete", "disabled", "aria-labelledby", "readonly", "type", "pattern", "min", "max", "maxlength", "inputmode", "placeholder"];
var _hoisted_2 = {
  key: 0,
  class: "tw-float-none tw-w-auto tw-overflow-hidden tw-block tw-p-0 tw-text tw-ml-2 tw-mb-2 tw-h-3 tw-invisible tw-max-w-full tw-transition-[max-width] tw-duration-[50ms] tw-ease-out tw-whitespace-nowrap"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  class: "tw-absolute tw-text-12 under-label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_floating_label = _resolveComponent("base-floating-label");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tw-inline-block tw-w-full tw-relative input-wrapper [&.has-right-icon.is-valid_.text-input-icon]:tw-mr-25px [&.has-right-icon.is-invalid_.text-input-icon]:tw-mr-25px", [_ctx.$attrs.class, {
      'tw-mt-10px': _ctx.labelText
    }, {
      'floating-label': _ctx.labelText
    }, _ctx.labelState === 'floating-label' ? 'floating-state' : 'inline-state', {
      'has-right-icon': _ctx.$attrs['with-right-icon'] !== undefined ? _ctx.$attrs['with-right-icon'] : !!_ctx.$slots.righticon
    }, {
      'has-left-icon': _ctx.$attrs['with-left-icon'] !== undefined ? _ctx.$attrs['with-left-icon'] : !!_ctx.$slots.leftIcon
    }, {
      'is-invalid': _ctx.isValid === false,
      'is-valid': _ctx.isValid
    }]])
  }, [_renderSlot(_ctx.$slots, "leftIcon", {}, undefined, true), _renderSlot(_ctx.$slots, "righticon", {
    handleClean: _ctx.handleClean,
    handleShowPasswd: _ctx.handleShowPasswd,
    curType: _ctx.type
  }, undefined, true), _createElementVNode("input", {
    id: _ctx.$attrs.id,
    ref: "baseInput",
    "data-cy": _ctx.$attrs['data-cy'],
    name: _ctx.$attrs.name,
    class: _normalizeClass(["tw-peer focus:tw-shadow-none focus:tw-outline-none !tw-border-none tw-truncate tw-h-[42px] tw-bg-no-repeat", [{
      'tw-rounded-xs': _ctx.radius
    }, {
      'input-element tw-block tw-w-full tw-appearance-none tw-outline-0 tw-h-12 tw-py-2 tw-px-4': _ctx.inputType === 'text-input'
    }, {
      'tw-text-w-secondary': _ctx.$attrs.disabled
    }, {
      'is-invalid invalid-bg !tw-pr-9': _ctx.isValid === false,
      'is-valid valid-bg !tw-pr-9': _ctx.isValid
    }, {
      'tw-pr-[42px]': _ctx.$attrs['with-right-icon'] !== undefined ? _ctx.$attrs['with-right-icon'] : !!_ctx.$slots.righticon
    }, {
      'tw-pl-[42px]': _ctx.$attrs['with-left-icon'] !== undefined ? _ctx.$attrs['with-left-icon'] : !!_ctx.$slots.leftIcon
    }, _ctx.inputClass]]),
    autocomplete: _ctx.$attrs.autocomplete === 'on' ? 'on' : 'off',
    disabled: _ctx.$attrs.disabled,
    "aria-labelledby": _ctx.$attrs.id,
    readonly: _ctx.$attrs.readonly,
    type: _ctx.type,
    pattern: _ctx.$attrs.pattern,
    min: _ctx.$attrs.min,
    max: _ctx.$attrs.max,
    maxlength: _ctx.$attrs.maxlength,
    inputmode: _ctx.$attrs.inputmode,
    placeholder: _ctx.$attrs.placeholder,
    onClick: _cache[0] || (_cache[0] =
    //@ts-ignore
    function () {
      return _ctx.handleClick && _ctx.handleClick(...arguments);
    }),
    onFocusin: _cache[1] || (_cache[1] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.handleFocusIn && _ctx.handleFocusIn(...arguments);
    }, ["stop"])),
    onFocusout: _cache[2] || (_cache[2] = _withModifiers($event => !_ctx.keepFloatingLabel && _ctx.handleFocusOut(_ctx.modelValue, false, _ctx.auto), ["stop"])),
    onInput: _cache[3] || (_cache[3] = _withModifiers(
    //@ts-ignore
    function () {
      return _ctx.handleInputChange && _ctx.handleInputChange(...arguments);
    }, ["stop"])),
    onKeydown: [_cache[4] || (_cache[4] = _withKeys($event => _ctx.$emit('keydown-enter-pressed'), ["enter"])), _cache[5] || (_cache[5] = $event => _ctx.$emit('keydown', $event))]
  }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1), _createElementVNode("fieldset", {
    class: _normalizeClass(["tw-absolute tw-text-left tw-m-0 tw-pointer-events-none tw-overflow-hidden tw-h-12 -tw-top-[5px] tw-right-0 tw-bottom-0 tw-left-0 tw-px-2 tw-py-0", [{
      'peer-focus:tw-border-2 peer-focus:tw-border-w-primary peer-focus:[&.is-invalid]:tw-border-w-danger tw-transition-[border] tw-duration-100 tw-ease-out tw-border tw-border-solid': _ctx.border,
      'tw-rounded-xs': _ctx.radius,
      'is-invalid tw-border-w-danger': _ctx.isValid === false,
      'is-valid tw-border-w-primary': _ctx.isValid,
      'tw-border-w-secondary': _ctx.isValid === null && _ctx.border
    }, {
      'no-floating-label tw-top-0': !_ctx.labelText
    }, _ctx.$attrs['fieldset-classes']]])
  }, [_ctx.labelText ? (_openBlock(), _createElementBlock("legend", _hoisted_2, [_createElementVNode("span", {
    class: _normalizeClass(["visible-label tw-opacity-0", [{
      'tw-mx-5px': _ctx.labelText
    }, {
      'tw-visible tw-inline-block': _ctx.labelState === 'floating-label'
    }, {
      'tw-invisible tw-hidden': _ctx.labelState === 'inline-label'
    }]]),
    innerHTML: _ctx.labelText
  }, null, 10 /* CLASS, PROPS */, _hoisted_3)])) : _createCommentVNode("v-if", true)], 2 /* CLASS */), _ctx.labelText ? (_openBlock(), _createBlock(_component_base_floating_label, {
    key: 0,
    for: _ctx.$attrs.id,
    "label-text": _ctx.labelText,
    "label-state": _ctx.labelState,
    "is-valid": _ctx.isValid,
    required: _ctx.$attrs.required,
    disabled: _ctx.$attrs.disabled,
    "label-classes": _ctx.$attrs['label-classes'],
    onClick: _ctx.handleFloatingLabelClick
  }, null, 8 /* PROPS */, ["for", "label-text", "label-state", "is-valid", "required", "disabled", "label-classes", "onClick"])) : _createCommentVNode("v-if", true), _createCommentVNode(" Feedback labels "), _ctx.isValid === false ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 1
  }, _renderList(_ctx.feedbackObj.invalid, (label, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: "".concat(_ctx.$attrs.id, "_invalid_").concat(index),
      class: "tw-text-w-danger tw-text-12 tw-mt-1",
      innerHTML: label
    }, null, 8 /* PROPS */, _hoisted_4);
  }), 128 /* KEYED_FRAGMENT */)) : _ctx.isValid === true ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 2
  }, _renderList(_ctx.feedbackObj.valid, (label, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: "".concat(_ctx.$attrs.id, "_valid_").concat(index),
      class: "tw-text-w-primary tw-text-12 tw-mt-1",
      innerHTML: label
    }, null, 8 /* PROPS */, _hoisted_5);
  }), 128 /* KEYED_FRAGMENT */)) : _createCommentVNode("v-if", true), _createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "under-label", {}, undefined, true)])], 2 /* CLASS */);
}